import React from 'react';
import { motion } from 'framer-motion';
import { FaTrophy, FaCertificate, FaMedal, FaStar } from 'react-icons/fa';
import './Achievements.css';

const Achievements = () => {
    const achievements = [
        {
            icon: FaCertificate,
            type: 'Certification',
            title: 'NPTEL – Introduction to Machine Learning',
            issuer: 'IIT Madras via NPTEL',
            year: '2024',
            color: '#667eea',
            badge: 'Certified'
        },
        {
            icon: FaCertificate,
            type: 'Certification',
            title: 'Python for Everybody',
            issuer: 'Coursera – University of Michigan',
            year: '2024',
            color: '#764ba2',
            badge: 'Certified'
        },
        {
            icon: FaTrophy,
            type: 'Achievement',
            title: 'Co-Founder – AGR Creative Tech Studio',
            issuer: 'Founded 2023',
            year: '2023',
            color: '#f093fb',
            badge: 'Startup'
        },
        {
            icon: FaMedal,
            type: 'Academic',
            title: 'B.Tech – AI & Data Science',
            issuer: 'Hindustan Institute of Technology & Science',
            year: '2023–2027',
            color: '#4facfe',
            badge: 'Pursuing'
        },
        {
            icon: FaStar,
            type: 'Project',
            title: 'MERN Stack Portfolio Website',
            issuer: 'Self-initiated & deployed project',
            year: '2024',
            color: '#43e97b',
            badge: 'Deployed'
        },
        {
            icon: FaCertificate,
            type: 'Certification',
            title: 'Web Development Bootcamp',
            issuer: 'Udemy',
            year: '2024',
            color: '#667eea',
            badge: 'Certified'
        },
    ];

    return (
        <section className="achievements section" id="achievements">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                >
                    <h2 className="section-title">Achievements</h2>
                    <p className="section-subtitle">Certifications &amp; Milestones</p>
                </motion.div>

                <div className="achievements-grid">
                    {achievements.map((item, index) => (
                        <motion.div
                            key={index}
                            className="achievement-card"
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.08 }}
                            viewport={{ once: true }}
                            whileHover={{ y: -6, transition: { duration: 0.2 } }}
                        >
                            <div className="achievement-icon" style={{ background: `${item.color}22`, color: item.color }}>
                                <item.icon />
                            </div>
                            <div className="achievement-body">
                                <div className="achievement-meta">
                                    <span className="achievement-type">{item.type}</span>
                                    <span className="achievement-badge" style={{ background: `${item.color}22`, color: item.color }}>
                                        {item.badge}
                                    </span>
                                </div>
                                <h3 className="achievement-title">{item.title}</h3>
                                <p className="achievement-issuer">{item.issuer}</p>
                            </div>
                            <div className="achievement-year">{item.year}</div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Achievements;
